module.exports = __webpack_public_path__ + "static/img/ecological_coreTechnology_icon.3eb2507.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ecological/ecological_coreTechnology_icon.png
// module id = CdEZ
// module chunks = 0